export interface UserNameFields {
    firstName?: string;
    lastName?: string;
    name?: string;
    first_name?: string;
    last_name?: string;
    email?: string;
}

export const getDisplayName = (user: UserNameFields | null | undefined): string => {
    if (!user) {
        return 'Unknown User';
    }

    // Try different field naming conventions
    const firstName = user.firstName || user.first_name;
    const lastName = user.lastName || user.last_name;
    const singleName = user.name;

    if (firstName && lastName) {
        return `${firstName} ${lastName}`;
    }

    if (firstName) {
        return firstName;
    }

    if (lastName) {
        return lastName;
    }

    if (singleName) {
        return singleName;
    }

    // Fallback to email if available
    if (user.email) {
        return user.email;
    }

    return 'Unknown User';
};
export const getInitials = (user: UserNameFields | null | undefined): string => {
    if (!user) {
        return 'U';
    }

    const firstName = user.firstName || user.first_name;
    const lastName = user.lastName || user.last_name;
    const singleName = user.name;

    if (firstName && lastName) {
        return `${firstName[0]}${lastName[0]}`.toUpperCase();
    }

    if (firstName) {
        return firstName.slice(0, 2).toUpperCase();
    }

    if (lastName) {
        return lastName.slice(0, 2).toUpperCase();
    }

    if (singleName) {
        // For single names, take first two letters or first letter if short
        return singleName.length >= 2
            ? singleName.slice(0, 2).toUpperCase()
            : singleName[0]?.toUpperCase() || '';
    }

    // Fallback to email
    if (user.email) {
        return user.email.slice(0, 2).toUpperCase();
    }

    return 'U';
};